<template>
  <div class="mainContainer" :style="loginImage">
    <TopHeader :pageTitle="pageHead" />
    <!----------------Main Page------------------------------------------>
    <div class="pageContainer shadow-lg rounded" fluid="sm">
      <SecondaryHeader @openSidepane="onClickChild" />

      <b-container fluid>
        <b-row class="customizeBtnRow">
          <b-col class="col-md-12">
            <b-button
              class="btn btn-success mr-2 approveAccessBtn float-right"
              @click="approveAccess()"
            >
              <i class="fa fa-check-circle mr-2"></i>Approve
            </b-button>
            <b-button
              variant="secondary"
              class="mr-2 float-right"
              @click="backhistory"
            >
              Back
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-card class="customizePanel" :class="bodyPanel">
              <ul class="list-group">
                <Buckets
                  v-for="(bucket, index) in userBuckets"
                  :key="index"
                  :bucket="bucket"
                  :index="index"
                  :userId="userId"
                  :is_visible="
                    'is_visible' in bucket ? bucket.is_visible : bucket.IsActive
                  "
                  @collectDataHandlerAccess="collectDataHandler"
                ></Buckets>
              </ul>
            </b-card>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import TopHeader from "@/components/BaseFiles/TopHeader.vue";
import SecondaryHeader from "@/components/BaseFiles/SecondHeader.vue";
import bgImage from "@/assets/img/dbTiles/BG.png";
import { mapGetters, mapActions } from "vuex";
import Buckets from "./Buckets.vue";

export default {
  name: "customizeAccess",
  components: {
    TopHeader,
    SecondaryHeader,
    Buckets,
  },
  computed: {
    ...mapGetters(["masterChartInfo", "editedUserDetials"]),
  },
  watch: {
    masterChartInfo: {
      deep: true,
      handler() {
        // console.log(
        //   "this.masterChartInfo--mounted-custo-++",
        //   this.masterChartInfo
        // );
        this.userBuckets = this.masterChartInfo;
      },
    },
  },
  data() {
    return {
      pageHead: "Customize Access",
      loginImage: {
        backgroundImage: "url(" + bgImage + ")",
      },
      userId: 0,
      userBuckets: [],
      bodyPanel: "bodyPanelOpen",
      updatedData: [],
    };
  },
  mounted() {
    this.userId = parseInt(this.$route.params.userId);
    if (this.userId) {
      this.getUserPermissionData();
    }
    this.updatedUserBucketData();
  },
  methods: {
    ...mapActions([
      "approvedUserById",
      "getEditedUserAccessDetails",
      "modifyUserAccessData",
    ]),
    async approveAccess() {
      if (this.updatedData.length) {
        let data = { userId: this.userId, data: this.updatedData };
        let responce = await this.modifyUserAccessData(data);
        this.getUserPermissionData();
        if (responce.status === 200 || responce.status === 202) {
          // console.log("responceeeeeeeee", responce);
          this.updatedData = [];
        }
      } else {
        alert("Please change somthing");
      }
    },
    collectDataHandler(collectData) {
      if (this.updatedData.length) {
        let index;
        this.updatedData.find((uData, indx) => {
          // console.log("++++uData+++", uData);
          if (collectData.objectname === uData.objectname) {
            index = indx;
            return true;
          }
        });
        if (index == undefined) {
          this.updatedData.push(collectData);
        } else {
          this.updatedData[index] = {};
          this.updatedData[index] = collectData;
        }
        // console.log("indexxxxxxxxxxxxxx", index);
      } else {
        this.updatedData.push(collectData);
      }

      // console.log("collectData", collectData);
      // console.log("this.updatedData", this.updatedData);
    },
    async getUserPermissionData() {
      await this.getEditedUserAccessDetails(this.userId);
    },
    updatedUserBucketData() {
      this.editedUserDetials.forEach((userbucket) => {
        if (this.masterChartInfo.length) {
          let parentIndex = this.masterChartInfo.findIndex(
            (bucket) => bucket.objectname === userbucket.objectname
          );
          let parentNode = this.masterChartInfo[parentIndex];
          let children = userbucket.child;
          let _children = parentNode.child;
          children.forEach((child) => {
            let childIndex = _children.findIndex(
              (_child) => _child.objectname === child.objectname
            );
            if (childIndex) _children.splice(childIndex, 1, child);
          });
          userbucket.child = _children;
          this.userBuckets.splice(parentIndex, 1, userbucket);
        }
      });
    },
    onClickChild(value) {
      if (value) {
        this.bodyPanel = "bodyPanel";
      } else {
        this.bodyPanel = "bodyPanelOpen";
      }
    },
    backhistory() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss">
.customizeWrapper {
  .customizeTable {
    width: 100%;
    background: #fff;
    height: 85%;
  }

  .caret2::before {
    content: "\25B8";
    color: black;
    display: inline-block;
    margin-right: 6px;
  }

  .active.caret2:before {
    content: "\25BE" !important;
  }

  .caret2-down::before {
    -ms-transform: rotate(90deg);
    -webkit-transform: rotate(90deg);
    transform: rotate(90deg);
  }

  .nested {
    display: none;
  }

  .active {
    display: block;
  }

  .child {
    display: none;
  }

  /* The switch - the box around the slider */
  .switch {
    position: relative;
    display: inline-block;
    width: 60px;
    height: 34px;
  }

  /* Hide default HTML checkbox */
  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  /* The slider */
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 26px;
    width: 26px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  input:checked + .slider {
    background-color: #2196f3;
  }

  input:focus + .slider {
    box-shadow: 0 0 1px #2196f3;
  }

  input:checked + .slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
  }

  /* Rounded sliders */
  .slider.round {
    border-radius: 34px;
  }

  .slider.round:before {
    border-radius: 50%;
  }

  .customizePanel {
    max-height: 75vh;
    overflow: auto;
  }

  .approveAccessBtn {
    display: inline-block;
    color: #fff;
  }

  .customizeBtnRow {
    a {
      color: #fff;
    }

    background: #fff;
    margin: 0 !important;
  }

  overflow-y: auto;
  height: 89%;
  padding: 2em;
}

/****Customize*****/
.customizePanel {
  height: 70vh;
  overflow: auto;

  li.list-group-item.not-collapsed {
    background: #2e38bb;
    color: #fff;
  }
  .bucketChildItem {
    li {
      border-top: 0;
      padding-top: 3px;
      padding-bottom: 3px;
      label {
        margin-bottom: 0;
      }
      input {
        margin-top: 3px;
      }
    }
  }
}
</style>
